import Icons from 'assets/icons';

interface ProgressProps {
  averageProgress: number;
  customClass?: string;
}

const Progress = ({
  averageProgress,
  customClass = '',
}: ProgressProps): React.JSX.Element => (
  <div className={`flex gap-1 items-center ${customClass}`}>
    <div className="font-semibold text-navy-800">{`${averageProgress}%`}</div>
    {averageProgress === 100 && <Icons.Trophy aria-hidden="true" />}
  </div>
);

export default Progress;
